<template>
  <div class="py-md-5">
    <div class="py-5 col-11 col-md-9 mx-auto d-flex align-items-center">
      <div class="bg-color-palette-1 text-white style-div-contact col-5 py-5 d-none d-md-block">
        <div class="mx-auto" style="max-width: 20rem">
          <h2 class="font-weight-bold my-3">Contáctanos</h2>
          <!-- <p class="my-3">
            <i class="fas fa-map-marker-alt"></i> Av. Los Leones 1200, sala 2A1, Providencia
          </p> -->
          <p class="my-3"><i class="fas fa-envelope"></i> Hola@subsidios.cl</p>
          <!-- <p class="my-3"><i class="fas fa-mobile"></i> +569 3619 4947</p> -->
        </div>
        <div class="d-flex justify-content-center">
          <a class="p-2" href="https://www.instagram.com/subsidios.cl/?hl=es-la" target="_blank"
            style="cursor: pointer">
            <i class="fab fa-instagram fa-lg text-white"></i>
          </a>
          <a class="p-2" href="https://www.facebook.com/portalsubsidios.cl" target="_blank" style="cursor: pointer">
            <i class="fab fa-facebook fa-lg text-white"></i>
          </a>
          <!-- <a class="p-2" href="https://api.whatsapp.com/send/?phone=56990333394&text&type=phone_number&app_absent=0"
            target="_blank" style="cursor: pointer">
            <i class="fab fa-whatsapp fa-lg text-white"></i>
          </a> -->
        </div>
      </div>
      <div class="style-form col-12 col-md-11 ml-auto px-0 px-md-2">
        <div class="col-12 col-md-7 ml-md-auto px-0 px-md-2">
          <div class="col-12 px-0">
            <h1 class="color-palette-2 font-weight-bold">Ponte en contacto</h1>
            <span class="color-text-default">Déjanos tus dudas y pronto te responderemos</span>
          </div>
          <form id="form-section-contact" class="row" @submit.prevent="sendContactForm" method="POST">
            <input type="hidden" name="_token" :value="csrf" />
            <div class="col-12">
              <input type="text" placeholder="Nombre Completo" name="name" v-model.trim="$v.form.name.$model" :class="!$v.form.name.$anyError
                ? 'form-control'
                : 'form-control form-error'
                " />
              <div class="error-data" v-if="$v.form.name.$dirty">
                <span v-if="!$v.form.name.required">Campo necesario</span>
              </div>
            </div>
            <div class="col-12">
              <input type="text" placeholder="Email" name="email" v-model.trim="$v.form.email.$model" :class="!$v.form.email.$anyError
                ? 'form-control'
                : 'form-control form-error'
                " />
              <div class="error-data" v-if="$v.form.email.$dirty">
                <span v-if="!$v.form.email.required">Campo necesario</span>
                <span v-if="!$v.form.email.email">Email inválido</span>
              </div>
            </div>
            <div class="col-12">
              <textarea cols="30" rows="10" placeholder="Déjanos tus dudas" name="message"
                v-model.trim="$v.form.message.$model" :class="!$v.form.message.$anyError
                  ? 'form-control'
                  : 'form-control form-error'
                  ">
              </textarea>
              <div class="error-data" v-if="$v.form.message.$dirty">
                <span v-if="!$v.form.message.required">Campo necesario</span>
              </div>
            </div>
            <div class="col-12">
              <privacy-consent
                id="contact-privacy"
                v-model="$v.form.privacy.$model"
                :invalid="$v.form.privacy.$dirty && !$v.form.privacy.accepted"
              />
            </div>
            <div class="col-12">
              <div class="col-12 col-md-10 col-lg-8 col-xl-5 ml-auto pr-0 pl-0 pl-md-3">
                <button type="submit" class="btn bg-color-palette-3 text-white btn-block" :disabled="formLoading">
                  {{ btnText }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="bg-color-palette-1 text-white style-div-contact col-12 py-5 d-md-none">
      <div class="col-11 mx-auto">
        <h2 class="font-weight-bold">Contáctanos</h2>
        <!-- <p><i class="fas fa-map-marker-alt"></i> Av. Los Leones 1200, sala 2A1, Providencia</p> -->
        <p><i class="fas fa-envelope"></i> Hola@subsidios.cl</p>
        <!-- <p><i class="fas fa-mobile"></i> +569 3619 4947</p> -->
      </div>
      <div class="d-flex justify-content-center">
        <a class="p-2" href="https://www.instagram.com/subsidios.cl/?hl=es-la" target="_blank" style="cursor: pointer">
          <i class="fab fa-instagram fa-lg text-white"></i>
        </a>
        <a class="p-2" href="https://www.facebook.com/portalsubsidios.cl" target="_blank" style="cursor: pointer">
          <i class="fab fa-facebook fa-lg text-white"></i>
        </a>
        <!-- <a class="p-2" href="https://api.whatsapp.com/send/?phone=56990333394&text&type=phone_number&app_absent=0"
          target="_blank" style="cursor: pointer">
          <i class="fab fa-whatsapp fa-lg text-white"></i>
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import PrivacyConsent from "../../components/PrivacyConsent.vue";

const accepted = (value) => value === true;

export default {
  name: "form-contact",
  components: { PrivacyConsent },
  data: () => ({
    csrf: document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content"),
    btnText: "Enviar mensaje",
    formLoading: false,
    form: {
      name: "",
      email: "",
      message: "",
      privacy: false,
    },
  }),
  methods: {
    sendContactForm() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        this.btnText = "Enviando...";
        this.formLoading = true;
        const rutaForm = window.BASE_URL + "/section-contact-form";
        $("#form-section-contact").attr("action", rutaForm).submit();
      }
    },
  },
  validations: {
    form: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      message: {
        required,
      },
      privacy: { accepted },
    },
  },
};
</script>

<style scoped>
.style-form {
  border-radius: 9px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
}

.color-text-default {
  color: #707070;
}

.style-div-contact {
  position: absolute;
  z-index: 10;
  border-radius: 18px;
}

@media (max-width: 768px) {
  .style-form {
    border-radius: 0;
    box-shadow: none;
  }

  .style-div-contact {
    position: static;
    z-index: 10;
    border-radius: 0;
  }
}
</style>
